<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2">
                <v-col sm="8" md="4" class="py-0">
                    <v-text-field v-model="props.search" append-icon="search" :label="$t('products.search')" single-line
                        hide-details class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"></v-text-field>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="4" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right tools-view-height mx-1" outlined color="secondary"
                                @click="modalExport = true;"
                                style="max-width: 40px !important; min-width: 40px !important">
                                <v-icon class="material-icons-outlined" small>downloading</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('products.export') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right tools-view-height mx-1" outlined color="secondary"
                                @click="modalImport = true;"
                                style="max-width: 40px !important; min-width: 40px !important">
                                <v-icon class="material-icons-outlined" small>cloud_upload</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('products.import') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right white_highlight--text tools-view-height mx-1"
                                color="secondary" :to="'/products/create'" v-permission="'product.create'"
                                style="max-width: 40px !important; min-width: 40px !important">
                                <v-icon class="material-icons-outlined" small>add</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('products.new') }}</span>
                    </v-tooltip>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable :pagination="[10, 20, 50, 100]"
                                :props="{ headers: headers, items: props.items, search: props.search }"
                                :itemsLength="props.meta.total" :options.sync="pagination.pendings"
                                @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"
                                @open-item="loadReserved"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
            <v-dialog v-model="modalImport" persistent max-width="90%" min-width="500px">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-spacer></v-spacer>
                        {{ $t('products.import_products') }}
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" small icon @click="stepper2 = 1; modalImport = false"><v-icon
                                small>close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-stepper v-model="stepper2">
                            <v-stepper-header>
                                <v-stepper-step :complete="stepper2 > 1" step="1" color="secondary">{{
                                    $t('products.select_products_file') }}</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="stepper2 > 2" step="2" color="secondary">{{
                                    $t('products.verify_data')
                                }}</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="stepper2 > 4" step="4" color="secondary">{{
                                    $t('products.results')
                                }}</v-stepper-step>
                                <v-divider></v-divider>
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1" class="mx-0 px-0">
                                    <v-card flat class="mb-5">
                                        <v-form ref="form2" lazy-validation>
                                            <v-row class="mx-3 px-0" justify="center" align="center">
                                                <v-col cols="10">
                                                    <v-file-input v-model="inputFile2" accept=".csv" color="secondary"
                                                        :label="$t('products.select_products_file')"></v-file-input>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn class="mx-0" small color="secondary" fab dark
                                                                v-bind="attrs" v-on="on" @click="stepper2 = 3">
                                                                <v-icon aria-hidden="false" color="white" small>
                                                                    help
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('products.help') }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card>

                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="right mr-2 white_highlight--text" color="secondary"
                                            @click="uploadProducts">
                                            {{ $t('products.next') }}
                                        </v-btn>
                                    </div>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <v-card flat class="mb-5">
                                        <v-card-text class="my-0 py-0">
                                            <p class="my-0 py-0">{{ readRows2.length }} {{
                                                $t('products.products_in_file')
                                                }}</p>
                                        </v-card-text>
                                        <v-simple-table v-if="this.readRows2.length > 0" fixed-header height="300px">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th v-for="(th, key) in sTHeaders2" :key="key"
                                                            class="text-left">{{ th }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, i) in readRows2" :key="i">
                                                        <td v-for="(td, j) in item.split(',')" :key="j">{{ td }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card>

                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mx-3" text
                                            @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []">{{
                                                $t('products.go_back') }}</v-btn>
                                        <v-btn color="secondary" class="white_highlight--text" @click="saveProducts">
                                            {{ $t('products.save_data') }}
                                        </v-btn>
                                    </div>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin
                                        modificarlos.</p>
                                    <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no
                                        utilice comas
                                        en ninguno de los campos, evite el uso de signos de interrogación, comillas o
                                        signos de
                                        admiración.</p>
                                    <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para
                                        familiarizarse con
                                        el formato.</p>
                                    <p class="py-0 my-0">4.- El archivo de productos debe ser formato CSV.</p>
                                    <p>5.- Si el campo presenta la leyenda 'Opcional' este campo puede ir vacío.</p>
                                    <p class="py-0 my-0">Columnas: </p>
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left" style="padding: 0 5px !important;">sku</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">description
                                                    </th>
                                                    <th class="text-left" style="padding: 0 5px !important;">client</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">unit</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">category
                                                    </th>
                                                    <th class="text-left" style="padding: 0 5px !important;">
                                                        restock_alert</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">weight</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">is_national
                                                    </th>
                                                    <th class="text-left" style="padding: 0 5px !important;">barcode
                                                    </th>
                                                    <th class="text-left" style="padding: 0 5px !important;">height</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">length</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">width</th>
                                                    <th class="text-left" style="padding: 0 5px !important;">size_unit
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>product 1</td>
                                                    <td>product description</td>
                                                    <td>Shop Online</td>
                                                    <td>Kilo</td>
                                                    <td>Juguetes</td>
                                                    <td>10</td>
                                                    <td>0.5</td>
                                                    <td>0</td>
                                                    <td>1000ABC000</td>
                                                    <td>1</td>
                                                    <td>1</td>
                                                    <td>1</td>
                                                    <td>CM/KG | IN/LB</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text" @click="stepper2 = 1">
                                            {{ $t('products.go_back') }}
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>

                                <v-stepper-content step="4">
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left" style="padding: 0 5px !important;">Message
                                                    </th>
                                                    <th class="text-left" style="padding: 0 5px !important;">Status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, i) in results" :key="i">
                                                    <td>{{ item.message }}</td>
                                                    <td>{{ item.status }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text"
                                            @click="stepper2 = 1; index(); results = []; modalImport = false">
                                            {{ $t('products.finish') }}
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalExport" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h5>{{ $t('products.download_products_list') }} </h5>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row align="center" justify="center" class="mt-3 text-center">
                            <v-col cols="12" class="py-0">
                                <client-selector class="py-0" ref="clientSelector" @getClients="v => items.clients = v"
                                    :is_national="2"></client-selector>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="12">
                                <h4>{{ $t('products.data_to_export') }}</h4>
                            </v-col>
                        </v-row>

                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0 py-0" color="blue_accent" disabled v-model="export_data.sku"
                                    :label="$t('products.sku')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.height"
                                    :label="$t('products.height')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.description"
                                    :label="$t('products.description')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.large"
                                    :label="$t('products.large')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.unit"
                                    :label="$t('products.unit')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.width"
                                    :label="$t('products.width')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.barcode"
                                    :label="$t('products.barcode')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.weight"
                                    :label="$t('products.weight')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.category"
                                    :label="$t('products.category')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.available_stock"
                                    :label="$t('products.available_stock_l')"></v-checkbox>
                            </v-col>
                        </v-row>
                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.restock_alert"
                                    :label="$t('products.restock_alert')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.reserved_stock"
                                    :label="$t('products.reserved_stock_l')"></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row align="center" justify="center" class="mt-1 ">
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.creation_date"
                                    :label="$t('products.creation_date')"></v-checkbox>
                            </v-col>
                            <v-col cols="6" class="py-0 my-0">
                                <v-checkbox class="mt-0" color="blue_accent" v-model="export_data.damaged_stock"
                                    :label="$t('products.damaged_stock_l')"></v-checkbox>
                            </v-col>
                        </v-row>

                        <div class="d-flex mt-4">
                            <v-spacer></v-spacer>
                            <v-btn class="mx-3" text @click="modalExport = false">{{ $t('products.cancel') }}</v-btn>
                            <v-btn color="secondary" class="white_highlight--text" @click="exportProducts">{{
                                $t('products.download') }} </v-btn>
                        </div>
                    </v-card-text>
                    <div class="marker1"></div>
                </v-card>
            </v-dialog>
            <v-dialog v-model="modalDetail" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center">
                            <h5>{{ $t('products.detail_stock') }}: {{ product_detail.sku }} </h5>
                        </v-row>
                    </v-card-title>
                    <v-row class="mx-0 px-5 py-0 my-0" justify="center" align="center">
                        <v-col cols="12" class="py-0 px-3">
                            <datatable v-if="product_detail.client.client_type == 'DEFAULT'"
                                :props="{ headers: headers_skus, items: product_detail.detailed_stock }"
                                @methodHandler="methodHandler"></datatable>
                            <datatable v-else :props="{ headers: headers_hd, items: product_detail.detailed_stock }"
                                @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0 px-5 pb-2 my-0" justify="end" align="end">
                        <btn-cancel :label="'products.cancel'" @click="modalDetail = false"></btn-cancel>
                    </v-row>
                </v-card>
            </v-dialog>

            <v-dialog v-model="modalShowReserved" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-row align="center" justify="center" class="mt-2">
                            <h5>{{ $t('products.reserved_product_of') }}: {{ product_reserved.item.sku }} </h5>
                        </v-row>
                    </v-card-title>
                    <v-row class="mx-0 px-5 py-0 my-0" justify="center" align="center">
                        <v-col cols="12" class="py-0 px-3">
                            <datatable v-if="product_reserved.reserved.success != undefined"
                                :props="{ headers: headers_reserved, items: product_reserved.reserved.success.arguments }"
                                @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                    <v-row class="mx-0 px-5 pb-2 my-0" justify="end" align="end">
                        <btn-cancel :label="'products.close'" @click="modalShowReserved = false"></btn-cancel>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color"
            style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>

<script>

import { showProductUseCase } from "../application/use_cases/show_product_use_case";
import { productIndexUseCase } from '../application/use_cases/product_index_use_case';
import { productShowReservedUseCase } from "../application/use_cases/product_show_reserved_use_case";
import { HttpProductRepository } from '../infrastructure/product_repository';

export default {
    computed: {
        rules_required() { return [v => !!v || this.$t('create_appointment.validations.required_field')] },
        headers() {
            return [
                { text: this.$t('products.sku'), align: "center", value: 'sku', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.description'), align: "center", value: 'description', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.unit'), align: "center", value: 'unit', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.client'), align: "center", value: 'client.name', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.class'), align: "center", value: 'classification', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.available_stock'), align: "center", value: 'stock.available', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.reserved_stock'), align: "center", value: 'stock.reserved', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.existence_stock'), align: "center", value: 'stock.quantity', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.damaged_stock'), align: "center", value: 'stock.damaged', class: 'text-uppercase', width: "10%" },
                { text: this.$t('products.actions'), align: "center", value: 'actions', class: 'text-uppercase', width: "10%" },
            ];
        },
        headers_skus() {
            return [
                { text: this.$t('product_details.location'), align: "center", value: 'location.name', class: 'text-uppercase' },
                { text: this.$t('product_details.pallet'), align: "center", value: 'pallet_per_location.pallet', class: 'text-uppercase' },
                { text: this.$t('product_details.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('product_details.reserved'), align: "center", value: 'reserved', class: 'text-uppercase' },
                { text: this.$t('product_details.batch'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('product_details.expiration'), align: "center", value: 'reference', class: 'text-uppercase' },
            ]
        },
        headers_hd() {
            return [
                { text: this.$t('product_details.location'), align: "center", value: 'location.name', class: 'text-uppercase' },
                { text: this.$t('product_details.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
                { text: this.$t('product_details.reserved'), align: "center", value: 'reserved', class: 'text-uppercase' },
                { text: this.$t('product_details.part_number'), align: "center", value: 'batch', class: 'text-uppercase' },
                { text: this.$t('product_details.weight'), align: "center", value: 'reference', class: 'text-uppercase' },
                { text: this.$t('product_details.container'), align: "center", value: 'container_number', class: 'text-uppercase' },
            ]
        },
        headers_reserved() {
            return [
                { text: this.$t('products.type'), align: "center", value: 'entity.type', class: 'text-uppercase' },
                { text: this.$t('products.identifier'), align: "center", value: 'entity.identifier', class: 'text-uppercase' },
                { text: this.$t('products.quantity'), align: "center", value: 'quantity', class: 'text-uppercase' },
            ]
        }
    },
    data() {
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalImport: false,
            modalExport: false,
            modalDetail: false,
            modalShowReserved: false,
            product_reserved: { reserved: "", item: ""},
            inputFile2: [],
            readFile2: '',
            readRows2: [],
            stepper2: 1,
            sTHeaders2: '',
            idProduct: '',
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            results: [],
            export_data: {
                sku: true,
                height: false,
                description: false,
                large: false,
                unit: false,
                width: false,
                barcode: false,
                weight: false,
                category: false,
                available_stock: false,
                restock_alert: false,
                reserved_stock: false,
                creation_date: false,
                damaged_stock: false
            },
            debounceTimer: null,
            product_detail: { client: {} },
            pagination: { page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false },
        }
    },
    mounted() {
        this.$store.state.module = "headers.products";
    },
    methods: {
        methodHandler(object) {
            this[object.methodName](object.parameters)
        },
        async index() {
            try {
                this.props.items = [];

                const result = await productIndexUseCase(this.props.meta.page, this.props.meta.per_page, this.props.search, this.props.sort_by, HttpProductRepository);

                this.props.items = result.data;
                this.props.meta = result.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        uploadProducts() {
            if (this.$refs.form2.validate()) {
                this.createInput2(this.inputFile2);
            }
        },
        createInput2(file) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.readRows2 = result.split('\r\n');
                    this.sTHeaders2 = this.readRows2[0].split(',');
                    this.readRows2.shift();
                    this.stepper2 = 2;
                },
                error => {
                    /* handle an error */
                    console.log(error);
                }
            );
        },
        saveProducts() {
            this.$store.state.loaderProps.visible = true;
            const products = [];
            if (this.readRows2.length > 0) {
                this.readRows2.forEach((x) => {
                    const num = x.split(',');
                    products.push({
                        'sku': num[0],
                        'description': num[1],
                        'client': num[2],
                        'unit': num[3],
                        'category': num[4],
                        'restock': num[5],
                        'weight': num[6],
                        'national': num[7],
                        'barcode': num[8],
                        'height': num[9],
                        'length': num[10],
                        'width': num[11],
                        'size_unit': num[12]
                    });
                })
                const lsToken = localStorage.getItem("access_token")
                this.$http.post(this.$store.state.chronosApi + 'importProducts', { products: products }, { headers: { Authorization: lsToken } })
                    .then((response) => {
                        if (response.data.status === 200) {
                            this.stepper2 = 4;
                            this.sTHeaders2 = [];
                            this.readRows2 = [];
                            this.inputFile2 = null;
                            this.results = response.data.results;
                        }
                    })
                    .catch((error) => {
                        console.log(error.response.data.message)
                        this.snackbar = {
                            visible: true,
                            color: 'error',
                            text: "error " + error.response.data.message
                        };
                    })
                    .finally(() => {
                        this.$store.state.loaderProps.visible = false;
                    })
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('products.validations.select_file_first')
                };
            }
        },
        exportProducts() {
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            var fields = "sku";

            if (this.export_data.height) fields += ",height";
            if (this.export_data.description) fields += ",description";
            if (this.export_data.large) fields += ",length";
            if (this.export_data.unit) fields += ",unit";
            if (this.export_data.width) fields += ",width";
            if (this.export_data.barcode) fields += ",barcode";
            if (this.export_data.weight) fields += ",weight";
            if (this.export_data.category) fields += ",category";
            if (this.export_data.available_stock) fields += ",stock_available";
            if (this.export_data.restock_alert) fields += ",reorder_alert";
            if (this.export_data.reserved_stock) fields += ",stock_reserved";
            if (this.export_data.creation_date) fields += ",created_at";
            if (this.export_data.damaged_stock) fields += ",stock_damaged";

            this.$http.get(this.$store.state.chronosApi + 'products/index/report?fields=' + fields + '&client_id=' + this.$store.state.clientId, { headers: { Authorization: lsToken } })
                .then((response) => {
                    var rows = response.data.split('\n');
                    var content = [];
                    rows.forEach(r => {
                        content.push(r.split(','));
                    })

                    let csvContent = "data:text/csv;charset=utf-8," + content.map(e => e.join(",")).join("\n");
                    var encodedUri = encodeURI(csvContent);
                    var downloadLink = document.createElement("a");
                    downloadLink.href = encodedUri;

                    downloadLink.download = "Productos - " + this.$store.state.clientName + " - " + new Date().toISOString().slice(0, 10) + ".csv";
                    downloadLink.click();
                })
                .catch((response) => {
                    this.$store.state.loaderProps.visible = false;
                    if (response.status !== 200) {
                        this.snackbar = {
                            visible: true,
                            color: 'red',
                            text: this.$t('pendings.responses.error')
                        }
                    }
                }).finally(() => {
                    this.modalExport = false;

                    this.export_data = {
                        sku: true,
                        height: false,
                        description: false,
                        large: false,
                        unit: false,
                        width: false,
                        barcode: false,
                        weight: false,
                        category: false,
                        available_stock: false,
                        restock_alert: false,
                        reserved_stock: false,
                        creation_date: false,
                        damaged_stock: false
                    };

                    this.$store.state.loaderProps.visible = false;
                });
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;

            if (options.sortBy.length > 0) {
                this.props.meta.page = 1;
                this.props.sort_by = [{ field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc' }];
            }
            else if (options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            }

            this.index();
        },
        async showProductDetailStock(product) {
            this.modalDetail = true;

            try {
                const result = await showProductUseCase(product, HttpProductRepository);

                this.product_detail = result;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        },
        async loadReserved(obj) {
            try {
                const result = await productShowReservedUseCase(obj.item.id, HttpProductRepository);
                this.modalShowReserved = true;

                this.product_reserved.item = obj.item;
                this.product_reserved.reserved = result;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null ? e : e.response.data.fault.message
                }
            }
        }
    },
    watch: {
        'props.search': async function () {
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}
</script>

<style></style>